/**
 * عکسی که روی دستگاهِ کاربر لود نشد — منطقِ «اصلاً گزارش‌کردنی هست؟» و
 * «در این نشست قبلاً گزارش شده؟».
 *
 * خوراکِ سربرگِ «عکس‌ها»ی ادمین (مایگریشن 0133): هر آدرسی که این‌جا تایید
 * شود، `reportBrokenImage` در `lib/report.ts` با `where_at='image.load'` به
 * `client_errors` می‌فرستد.
 *
 * چرا فایلِ جدا و بدونِ هیچ import: این تصمیم‌ها باید با `npm test` آزموده
 * شوند، و تستِ unit نباید زنجیره‌ی report→supabase را import کند — همان
 * قاعده‌ای که scope.test.ts می‌گوید: کوئریِ بدونِ شبکه اجرا نمی‌شود و mockش
 * فقط خودِ mock را تست می‌کند. خودِ فرستادن آن‌طرف می‌ماند، تصمیم این‌جا.
 */

/**
 * اگر این آدرس گزارش‌کردنی است، نسخه‌ی تمیزشده‌اش؛ وگرنه null.
 *
 * فقط http(s): آدرسِ `file://` یعنی کشِ خرابِ روی دیسک — که fallbackِ
 * `ImageOrTiles` همان لحظه حلش می‌کند و ربطی به عکسِ خراب در اینترنت ندارد —
 * و `data:`/`blob:` چیزِ محلی است که ادمین کاری‌اش نمی‌تواند بکند.
 */
export function reportableImageUrl(url: string | null | undefined): string | null {
  const u = (url ?? '').trim();
  if (!/^https?:\/\//i.test(u)) return null;
  // سقفِ ستونِ message در client_errors (همان بریدنی که reportError می‌کند).
  return u.slice(0, 2000);
}

const seenThisSession = new Set<string>();

/**
 * اگر این آدرس باید همین حالا گزارش شود، همان را برمی‌گرداند و علامت می‌زند؛
 * وگرنه null.
 *
 * هر آدرس در هر نشست فقط یک بار: یک فهرستِ اسکرول‌شونده می‌تواند همان عکسِ
 * خراب را ده بار رندر کند و ده ردیفِ تکراری چیزِ تازه‌ای نمی‌گوید — شدتِ
 * واقعی از شمارِ کاربرها درمی‌آید (ستونِ `users` گزارش)، نه شمارِ رندرها.
 */
export function claimBrokenImage(
  url: string | null | undefined, seen: Set<string> = seenThisSession,
): string | null {
  const u = reportableImageUrl(url);
  if (!u || seen.has(u)) return null;
  seen.add(u);
  return u;
}
